import { useEffect, useMemo, useState } from "react";
import { Column } from "devextreme-react/data-grid";
import { Button, DataGrid, Popup, RadioGroup, SelectBox } from "devextreme-react";

import { ReviewCustomersApi } from "@/shared/api/ReviewCustomers.api";
import { filterOnEventType, generateFilterConditions, RunHistoryLogDetailColumns } from "@/shared/business/ReviewCustomers";
import { CustomerUpdateRunDetailLine } from "@/shared/models/CustomerUpdateRunDetail";
import { setToastInfo } from "@/redux/shareSlice";
import { store } from "@/store/store";
import { Utilities } from "@/shared/utils/utilities";

interface IProps {
  visible: boolean;
  closeForm: (reloadData: boolean) => Promise<void>;
}

const UpdateRunHistoryForm = ({ visible, closeForm }: IProps) => {
  const [customerUpdateRunData, setCustomerUpdateRunData] = useState({} as any);
  const [selectedRun, setSelectedRun] = useState("");
  const [logFilter, setLogFilter] = useState("");
  const [updateRunDetails, setUpdateRunDetails] = useState<CustomerUpdateRunDetailLine[]>([]);

  useEffect(() => {
    loadingData();
  }, []);

  const logFilterRadioItems = useMemo(() => generateFilterConditions(updateRunDetails), [updateRunDetails]);
  const filteredUpdateRunDetails = useMemo(() => filterOnEventType(logFilter, updateRunDetails), [logFilter, updateRunDetails]);

  const loadingData = async () => {
    setCustomerUpdateRunData(await ReviewCustomersApi.getCustomerUpdateRuns());
  };

  const handleSelectedRunChange = async (value: string) => {
    setSelectedRun(value);
    const details = await ReviewCustomersApi.getCustomerUpdateRunDetails(value);
    details && details.history && setUpdateRunDetails(details.history);
  };

  const handleLogFilterchange = (value: string) => {
    setLogFilter(value);
  };

  const handleExport = async () => {
    var fileName = await ReviewCustomersApi.dumpSurchargeEventCalculationResults(selectedRun);
    !Utilities.isNullOrEmptyString(fileName) &&
      store.dispatch(setToastInfo(`History is downloaded successfully as ${fileName}.`));
  };

  const handleCancel = async () => {
    closeForm && (await closeForm(false));
  };

  return (
    <>
      <Popup visible={visible} onHiding={handleCancel} dragEnabled={true} showTitle={true} title={"Customer Update Run History"} width="75%" height="auto" maxHeight={"90%"}>
        <h5 className="d-inline-block">Select a run date to view :</h5>
        <SelectBox
          className="ms-3 d-inline-block"
          value={selectedRun}
          displayExpr="value"
          valueExpr="name"
          dataSource={customerUpdateRunData}
          onValueChange={handleSelectedRunChange}
        ></SelectBox>
        <hr></hr>

        {updateRunDetails.length > 0 ? (
          <>
            <div className="ms-5 log-filter-label d-inline-block">Showing:</div>
            <RadioGroup
              className="ms-3 d-inline-block"
              items={logFilterRadioItems}
              value={logFilter}
              displayExpr="name"
              valueExpr="value"
              onValueChange={handleLogFilterchange}
              layout="horizontal"
            />

            <DataGrid
              dataSource={filteredUpdateRunDetails}
              showBorders={true}
              repaintChangesOnly={true}
              allowColumnResizing={true}
              allowColumnReordering={true}
              hoverStateEnabled={true}
              wordWrapEnabled={false}
              columnAutoWidth={true}
              noDataText="No Data"
              height={500}
            >
              {RunHistoryLogDetailColumns.map((item, key) => (
                <Column key={key} dataField={item.dataField} caption={item.caption} />
              ))}
            </DataGrid>
          </>
        ) : (
          <div className="dx-datagrid-nodata mt-5">No Data</div>
        )}

        <div className="text-end">
          {updateRunDetails.length > 0 ? (
            <Button width={270} type="default" className="me-2" onClick={handleExport}>
              EXPORT LOG DATA TO CSV FILE
            </Button>
          ) : (
            <></>
          )}

          <Button width={70} onClick={handleCancel}>
            CANCEL
          </Button>
        </div>
      </Popup>
    </>
  );
};

export default UpdateRunHistoryForm;
